import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import { ButtonVariant } from '../../core/enums';
import { styles } from './forgot-password-styles';
import { Flex } from '@chakra-ui/react';
import theme from '../../theme';
import Input from '../../components/input/input';
import deepEqual from 'deep-equal';
import React, { useEffect, useState } from 'react';
import { LOAD_STATES } from '../../reducers/common';
import './forgot-password.scss';
const ForgotPasswordForm = (props)=>{
    const { handleUsernameSubmission, handleCancel, initializeForgotPassword, loadState } = props;
    const [username, changeUsername] = useState('');
    useEffect(()=>{
        initializeForgotPassword();
    }, [
        initializeForgotPassword
    ]);
    const handleUsernameChange = (e)=>{
        e.preventDefault();
        changeUsername(e.target.value);
    };
    const handleUsernameClick = (e)=>{
        e.preventDefault();
        handleUsernameSubmission(username);
    };
    const handleCancelClick = (e)=>{
        e.preventDefault();
        handleCancel();
    };
    const classes = styles();
    let inner;
    if (deepEqual(loadState, LOAD_STATES.done)) {
        inner = /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    children: "Request Submitted "
                }),
                ' ',
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("span", {
                        children: "A password reset email has been sent to the email address of the associated account."
                    })
                }),
                /*#__PURE__*/ _jsx(Button, {
                    size: ButtonSize.MD,
                    label: 'Return',
                    backgroundColor: theme.colors.accent[100],
                    color: theme.colors.text['light'],
                    name: "Return",
                    dataTestId: "return",
                    onClick: handleCancelClick
                })
            ]
        });
    } else if (loadState === LOAD_STATES.started) {
        inner = /*#__PURE__*/ _jsx("div", {
            className: "loading loading-lg"
        });
    } else {
        inner = /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    children: "Forgot Password"
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("span", {
                        children: "Please enter your username to begin the password reset process."
                    })
                }),
                /*#__PURE__*/ _jsxs("form", {
                    className: 'forgot-password-form',
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ _jsx("label", {
                                    className: "form-label",
                                    htmlFor: "input-email-1",
                                    children: "Username"
                                }),
                                /*#__PURE__*/ _jsx(Input, {
                                    autoFocus: true,
                                    onChange: handleUsernameChange,
                                    name: 'username',
                                    placeholder: '',
                                    type: 'text'
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            className: "form-row",
                            sx: classes.btnHeader,
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    size: ButtonSize.MD,
                                    label: 'Submit',
                                    backgroundColor: theme.colors.accent[100],
                                    color: theme.colors.text['light'],
                                    name: "Submit",
                                    dataTestId: "submitResetPass",
                                    onClick: handleUsernameClick,
                                    type: "submit"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    label: "Cancel",
                                    variant: ButtonVariant.LINKS,
                                    height: '24px',
                                    dataTestId: "cancel",
                                    onClick: handleCancelClick
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: 'forgot-password-form-container',
        children: inner
    });
};
export default ForgotPasswordForm;
